import { serviceHelper } from '../utils/serviceHelper'

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_SCHEDULER_URL}`)
}

export const exportReportFilter = async (body) => {
  const schedulerApi = getAxiosCreate()
  const { data } = await schedulerApi.post('/schedulings/export', body, { responseType: 'blob' })
  return data
}

/* export const sendQuestionMessage = async (schedulingId, questionMessage) => {
  const schedulerApi = getAxiosCreate()
  const scheduling = await schedulerApi.post(`/schedulings/${schedulingId}/send-question-message`, { questionMessage })
  return scheduling
}

export const setAnswerRead = async (schedulingId) => {
  const schedulerApi = getAxiosCreate()
  const scheduling = await schedulerApi.post(`/schedulings/${schedulingId}/set-answer-read`, {})
  return scheduling
}
 */

export const exportProfessionalSchedule = async (params) => {
  const schedulerApi = getAxiosCreate()
  const { data } = await schedulerApi.get('/report/professional-schedule', {
    params,
    responseType: 'blob'
  })
  return data
}

export const getAvailableDays = async ({ partner, service, additionalServices, breed, temperament, month, year }) => {
  const schedulerApi = getAxiosCreate()
  const { data } = await schedulerApi.get('/schedulings/availability', {
    params: {
      partner,
      service,
      additionalServices,
      breed,
      temperament,
      month,
      year
    }
  })
  return data
}
